import classNames from 'classnames'
import React from 'react'
import { isMobile } from 'react-device-detect'
import useTranslation from '../../../../hooks/useTranslation'

export const IncludeAddTooltip = (props: any) => {
  const { setTooltipStatus } = props
  const { t } = useTranslation()

  return (
    <div
      className={classNames(
        'flex flex-col p-[26px] gap-[10px] bg-white  w-[330px]   border-[3px] border-main  rounded-[20px] z-50',
        {
          ' fixed left-[40%] bottom-[25%] ': !isMobile,
          ' fixed bottom-[25%]  ': isMobile,
        }
      )}
    >
      <div className="flex items-center justify-between">
        <p className=" leading-[19.2px] text-base   text-[10px]">
          <span className="font-bold text-[20px]">{t('productVideoEditor.includeAddTooltip.title')}</span>
        </p>
        <button
          type="button"
          onClick={() => setTooltipStatus((prev: boolean) => !prev)}
        >
          <img
            src="assets/img/Icon_x.png"
            alt="icon_x"
            height={24}
            width={24}
          />
        </button>
      </div>
      <p>
        {t('productVideoEditor.includeAddTooltip.description')} <br />
        {t('productVideoEditor.includeAddTooltip.policyNote')}
      </p>
      <div className="flex flex-col gap-4">
        {' '}
        <img
          src="assets/img/includeAdd_add.png"
          alt=""
          className="w-[266px] h-[150px]"
        />
        <img
          src="assets/img/includeAdd_minus.png"
          alt=""
          className="w-[266px] h-[150px]"
        />
      </div>
    </div>
  )
}
